const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Ensure dataLayer exists (loaded by GTM snippet, but safe fallback)
if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer || [];
}

const pushDataLayer = (payload) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

// Backend event tracking (existing dashboard analytics)
export const trackEvent = async (eventType, buttonId = null) => {
  try {
    await fetch(`${BACKEND_URL}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: eventType,
        page: window.location.pathname,
        button_id: buttonId,
        country: null,
        city: null,
        referrer: document.referrer || null,
        user_agent: navigator.userAgent,
      }),
    });
  } catch (e) {
    // silent
  }
};

// ============================
// Public trackers
// Chaque tracker pousse dans window.dataLayer ET envoie au backend.
// ============================

export const trackPageView = () => {
  pushDataLayer({ event: 'page_view' });
  trackEvent('page_view');
};

export const trackButtonClick = (label) => {
  pushDataLayer({ event: 'cta_click', label });
  trackEvent('button_click', label);
};

export const trackFormStart = () => {
  pushDataLayer({ event: 'form_start' });
  trackEvent('form_start');
};

export const trackFormComplete = () => {
  pushDataLayer({ event: 'form_complete' });
  trackEvent('form_complete');
};

// Se déclenche UNIQUEMENT quand un RDV est réellement confirmé.
export const trackBookingConfirmed = () => {
  pushDataLayer({ event: 'booking_confirmed' });
  pushDataLayer({ event: 'lead_submitted' });
  trackEvent('booking_confirmed');
};

const analytics = {
  trackPageView,
  trackButtonClick,
  trackFormStart,
  trackFormComplete,
  trackBookingConfirmed,
};

export default analytics;
